// XXX.XXX.XXX-XX
const CPF_MASK = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
// XX.XXX.XXX/XXXX-XX
const CNPJ_MASK = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
// XXXXX-XXX
const ZIP_MASK = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];

// XX,X or X,X or X
const PRESCRIPTION_MASK = function(userInput) {
    let numbers = userInput.match(/\d/g);
    let numberLength = 0;
    if(numbers) {
        numberLength = numbers.join('').length;
    }
    if (numberLength === 3) {
        return [/\d/, /\d/, '.', /\d/];
    } else if (numberLength === 2) {
        return [/\d/, '.', /\d/];
    } else {
        // return ['.', /\d/];
        return [/\d/, '.'];
    }
}

// (XX) XXXXX-XXXX or (XX) XXXX-XXXX
const PHONE_MASK = function(userInput) {
    let numbers = userInput.match(/\d/g);
    let numberLength = 0;
    if (numbers) {
        numberLength = numbers.join('').length;
    }
    if (numberLength > 10) {
        return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    } else {
        return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
};

// XX/XX/XXXX
const DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

export { CPF_MASK, CNPJ_MASK, PHONE_MASK, ZIP_MASK, DATE_MASK, PRESCRIPTION_MASK };
